<template>
  <div :class="['content-box', { 'no-card': disableCard }]">
    <div class="m-2 pl-3 text-center" v-show="isLoading">
      <font-awesome-icon
        :icon="['fa', 'circle-notch']"
        class="fa-spin m-auto spinner fa-5x egx-partner-color"
      />
    </div>
    <div :class="['card-body', { 'no-card': disableCard }]" v-show="!isLoading">
      <span class="mb-4 egx-partner-color">
        <h2 v-html="pageConfiguration.existingProjectHeader" />
      </span>
      <div class="mt-4" v-html="pageConfiguration.existingProjectInstructions" />
      <applicationCard class="mt-4" @number-of-applications="updateApplicationSize"/>
      <div class="mt-4 mb-4" v-html="pageConfiguration.lowerlabelInstructions" />
      <div class="applied-projects-buttons">
        <button class="cancel-button btn " @click.prevent="$event => handleCancel()">Cancel</button>
        <button class="confirm-button btn" @click.prevent="$event => handleContinue()">Continue</button>
      </div>
    </div>
  </div>
</template>
<script>
import applicationCard from './ApplicationCard.vue';

export default {
  components: {
    applicationCard,
  },
  data() {
    return {
      disableCard: false,
      totalApplications: null,
      pageConfiguration: {},
      isLoading: false,
    };
  },

  created() {
    const projectCreation = localStorage.getItem('projectCreation');
    if (!projectCreation || !this.fulfill_sync_details.allow_update_created_projects) {
      this.$router.push({ name: 'applicationsShowAll' });
      return;
    }
    this.isLoading = true;
    this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
      task_name: 'customerapp',
      prog_id: this.$route.query.programId,
    })
    .then((response) => {
      this.pageConfiguration = response.customerapp || {};
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  computed: {
    fulfill_sync_details() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details;
    },
  },

  methods: {
    updateApplicationSize(size) {
      this.totalApplications = size;
    },
    handleCancel() {
      localStorage.removeItem('projectCreation');
      this.$router.push({ name: 'applicationsShowAll' });
    },
    handleContinue() {
      localStorage.setItem('isContinue', true);
      localStorage.removeItem('projectCreation');
      this.$router.push({ path: 'applications/new', query: { programId: this.$route.query.programId } });
    },
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/stylesheets/components/project/applied-projects.scss';
</style>
